import { IAppState } from '../../../../../AppModulesWrapper';

export const selectPromotionTypeChangeReason = (state: IAppState): null | string => {
  return state.servicePickerWidgetV2.promotion.banner?.promotionTypeChangeReason || null;
};
